import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Badge = ({ content, type, className }) => {
    const classes = classNames({
      'hu-badge': true,
      [`hu-badge-${type}`]: !!type,
      [className]: !!className,
    });

    return (
      <span className={classes} key={content}>
        {content}
      </span>
    );
};

Badge.propTypes = {
  content: PropTypes.node.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Badge.defaultProps = {
  content: '',
  type: 'member',
  className: '',
};

export default Badge;
